import { Instagram } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/ahmed_0556641963_decor";
const TIKTOK_URL = "https://www.tiktok.com/@ahmmm2023?_r=1&_t=ZS-955oiIRmsQ0";

const TikTokIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.75a8.28 8.28 0 004.76 1.5V6.8a4.84 4.84 0 01-1-.11z" />
  </svg>
);

interface SocialIconsProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeMap = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-12 h-12",
};

const iconSizeMap = {
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
};

const SocialIcons = ({ size = "md", className = "" }: SocialIconsProps) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        className={`${sizeMap[size]} rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white hover:scale-110 transition-transform duration-200`}
      >
        <Instagram className={iconSizeMap[size]} />
      </a>
      <a
        href={TIKTOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        className={`${sizeMap[size]} rounded-lg bg-foreground flex items-center justify-center text-background hover:scale-110 transition-transform duration-200`}
      >
        <TikTokIcon className={iconSizeMap[size]} />
      </a>
    </div>
  );
};

export default SocialIcons;
